module.exports = __webpack_public_path__ + "static/media/limkokwing-net.900f305a.png";